import axios from "axios";
import React from "react";

export default function AddEvent() {
  const eventData = {
    eventName: "Sarmang Dehradun Marathon",
    date: "Oct 08, 2023",
    time: "04:30 AM (IST)",
    location: "Dehradun, India",
    venue: "Maharana Pratap Sports College, Raipur, Dehradun, India",
    banner: "",
    eventInformation: `<p>Sarmang Dehradun Marathon</p> <br />
        <p>(AIMS Certified)</p>
        <br />
        <p>
          The weather of Dehradun is very supportive for long distance
          runners. The lovely weather, mountains and the beauty of doon
          valley attracts many tourists from various parts of India and the
          world.
        </p>
        <p>
          Started in 2021 by Sarmang Adventure Tours with a vision to
          develop Dehradun as a marathon and adventure sports hub.
        </p>
        <p>
          The course of Sarmang Dehradun Marathon(42.195km), Sarmang
          Dehradun Half Marathon(21.0975km), Sarmang Dehradun 10km and
          Sarmang Dehradun 5km is certified by World Athletics is certified
          by World Athletics.
        </p>
        <p>
          Sarmang Dehradun Marathon is an associate member of AIMS
          (Association of International Marathons and Distance Races).
        </p>
        <p>
          The 2023 Sarmang Dehradun Marathon will be a qualifying race in
          the Abbott World Marathon Marathons Wanda Age Group World
          Rankings.
        </p>
        <p>Race Date: Sunday, 08 October 2023</p>
        <p>Distance: 42.195 KM</p>
        <p>Reporting time: 4:00 am</p>
        <p>
          Reporting Place: Maharana Pratap Sports College, Raipur, Dehradun
        </p>
        <p>Race start time: 5:00 am</p>
        <p>Cutoff Time: 6:30 Hrs</p>
        <p>Minimum age eligibility: 18+ Years as on race day</p>
        <p>Age Categories</p>
        <p>
          {" "}
          18 - 29 Years Male/Female
          <br />
          30 - 39 Years Male/Female
          <br />
          40 - 49 Years Male/Female
          <br />
          50 - 59 Years Male/Female
          <br />
          60 - 69 Years Male/Female
          <br />
          70+ Years Male/Female
        </p>
        <p>
          Cash Prize
          <br />
          For top 3 overall male/female full marathon winners
        </p>
        <p>Full Marathon (Overall)</p>
        <p>
          Male
          <br />
          I. 50,000/-
          <br />
          II. 30,000/-
          <br />
          III. 20,000/-
        </p>
        <p>
          Female
          <br />
          I. 50,000/-
          <br />
          II. 30,000/-
          <br />
          III. 20,000/-
        </p>
        <p></p>
        <p>Race Website: https://sarmangdehradunmarathon.sarmang.com</p>
        <p></p>
        <p>WAIVER OF LIABILITY:</p>
        <p>
          I know that running a road race is a potentially hazardous
          activity, which could cause injury or death. I will not enter and
          participate unless I am medically able and properly trained, and
          by my ticket booking, I certify that I am medically able to
          perform this event, and am in good health, and I am properly
          trained. I agree to abide by any decision of a race official
          relative to any aspect of my participation in this event,
          including the right of any official to deny or suspend my
          participation for any reason whatsoever. I attest that I have read
          the rules of the race and agree to abide by them. I assume all
          risks associated with running in this event, including but no
          limited to: falls, physical contact with other participants,
          volunteers, race personnel, contract service providers, employees,
          and spectators including the potential the contraction of a
          communicable disease resulting from contact with other
          participants, volunteers, race personnel, contract service
          providers, employees, and spectators. I assume all risks
          including: the effects of the weather; high heat and/or humidity;
          freezing cold temperatures; traffic and the conditions of the road
          including surrounding terrain. I further agree to abide by the
          Ministry of Home Affairs and Ministry(MHA) of Health and Family
          Welfare (MoHFW), Government of India recommendations for the
          prevention of the spread of the 2019 Novel Coronavirus Disease
          (COVID-19) and other communicable diseases I assume all such risks
          being known, appreciated, and accepted by me.
        </p>
        <p>
          I understand that bicycles, skateboards, baby joggers/strollers,
          roller skates or inline skates, animals, and personal music
          players are not allowed in the race, and I will abide by all race
          rules. Having read this waiver and knowing these facts and
          inconsideration of your accepting my entry, I, for myself and
          anyone entitled to act on my behalf, waive and release the SARMANG
          DEHRADUN MARATHON, the city of DEHRADUN, and SARMANG ADVENTURE
          TOURS, all event sponsors, their representatives and successors
          from all claims or liabilities of any kind arising out of my
          participation in this event, even though that liability may arise
          out of negligence or carelessness on the part of the persons named
          in this waiver. In addition, I acknowledge the contagious nature
          of COVID-19 and other communicable diseases and voluntarily assume
          the risk that I may be exposed to or infected by COVID-19 and/or
          other communicable diseases by participating in this event. I
          acknowledge that such exposure or infection may result in personal
          injury, illness, permanent disability, and/or death. I understand
          that the risk of becoming exposed to or infected by COVID-19 in
          connection with my participation in this event and personally
          assume this risk.
        </p>
        <p>
          I grant permission to all of the foregoing to use my photographs,
          motion pictures, recordings or any other record of this event for
          any legitimate purposes. I understand that this event does not
          provide for refunds in the event of a cancellation, and by signing
          this waiver, I consent that I am not entitled to a refund if the
          event is cancelled before or during the event.
        </p>`,
    images: ["", ""],
    tickets: [
      {
        name: "Full Marathon",
        description:
          "Full Marathon 42.195 KM. Participant must be 18+ years on race day.",
        price: 1875,
        mrp: 900, // optional
        quantity: 100,
        formFields: [
          {
            question: "Full Name",
            type: "text",
            required: true,
          },
          {
            question: "Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Name",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Email",
            type: "email",
            required: true,
          },
          {
            question: "Blood Group",
            type: "radio",
            options: ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-", "A1B+"],
            required: true,
          },
          {
            question: "Gender",
            type: "radio",
            options: ["Male", "Female", "Others"],
            required: true,
          },
          {
            question: "City",
            type: "text",
            required: true,
          },
          {
            question: "Date of Birth (DD/MM/YYYY)",
            type: "text",
            required: true,
          },
          {
            question: "Proof of Date of Birth.",
            type: "file",
            required: true,
          },
          {
            question:
              "Upload certificate of last full marathon ran in last 1.5 year.",
            type: "file",
            required: false,
          },
          {
            question: "Website link of last full marathon result.",
            type: "text",
            required: false,
          },
          {
            question: "Upload certificate of last half marathon.",
            type: "file",
            required: false,
          },
          {
            question: "Website link of last half marathon result.",
            type: "text",
            required: false,
          },
          {
            question: "Full marathons ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "more"],
            required: true,
          },
          {
            question: "Half marathons ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "more"],
            required: true,
          },
          {
            question: "10K ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "5", "5+"],
            required: true,
          },
          {
            question: "5K ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "5", "5+"],
            required: true,
          },
          {
            question: "TShirt Size.",
            type: "radio",
            options: [
              "XS: 34",
              "S: 36",
              "M: 38",
              "L: 40",
              "XL: 42",
              "XXL: 44",
              "XXS: 32",
              "30",
              "28",
              "26",
              "24",
            ],
            required: true,
          },
          {
            question: "I have read and accept the liablity waiver.",
            type: "checkbox",
            options: ["Read and Accept"],
            required: true,
          },
          {
            question: "Country",
            type: "text",
            required: true,
          },
          {
            question: "Nationality",
            type: "text",
            required: true,
          },
          {
            question: "Group/Organisation Name.",
            type: "text",
            required: false,
          },
          {
            question: "Group ID/Ticket",
            type: "file",
            required: false,
          },
        ],
      },
      {
        name: "Half Marathon",
        description:
          "Half Marathon 21.0975 KM. Participant must be 18+ years on race day.",
        price: 1650,
        quantity: 150,
        formFields: [
          {
            question: "Full Name",
            type: "text",
            required: true,
          },
          {
            question: "Email",
            type: "email",
            required: true,
          },
          {
            question: "Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Name",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Blood Group",
            type: "radio",
            options: ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-", "A1B+"],
            required: true,
          },
          {
            question: "Gender",
            type: "radio",
            options: ["Male", "Female", "Others"],
            required: true,
          },
          {
            question: "City",
            type: "text",
            required: true,
          },
          {
            question: "Date of Birth (DD/MM/YYYY)",
            type: "text",
            required: true,
          },
          {
            question: "Proof of Date of Birth.",
            type: "file",
            required: true,
          },
          {
            question: "Upload certificate of last half marathon.",
            type: "file",
            required: false,
          },
          {
            question: "Website link of last half marathon result.",
            type: "text",
            required: false,
          },
          {
            question: "Half marathons ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "more"],
            required: true,
          },
          {
            question: "10K ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "5", "5+"],
            required: true,
          },
          {
            question: "5K ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "5", "5+"],
            required: true,
          },
          {
            question: "TShirt Size.",
            type: "radio",
            options: [
              "XS: 34",
              "S: 36",
              "M: 38",
              "L: 40",
              "XL: 42",
              "XXL: 44",
              "XXS: 32",
              "30",
              "28",
              "26",
              "24",
            ],
            required: true,
          },
          {
            question: "I have read and accept the liablity waiver.",
            type: "checkbox",
            options: ["Read and Accept"],
            required: true,
          },
          {
            question: "Country",
            type: "text",
            required: true,
          },
          {
            question: "Nationality",
            type: "text",
            required: true,
          },
          {
            question: "Group/Organisation Name.",
            type: "text",
            required: false,
          },
          {
            question: "Group ID/Ticket",
            type: "file",
            required: false,
          },
        ],
      },
      {
        name: "10K Run",
        description: "10K Run",
        price: 1200,
        quantity: 50,
        formFields: [
          {
            question: "Full Name",
            type: "text",
            required: true,
          },
          {
            question: "Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Name",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Email",
            type: "email",
            required: true,
          },
          {
            question: "Blood Group",
            type: "radio",
            options: ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-", "A1B+"],
            required: true,
          },
          {
            question: "Gender",
            type: "radio",
            options: ["Male", "Female", "Others"],
            required: true,
          },
          {
            question: "City",
            type: "text",
            required: true,
          },
          {
            question: "Date of Birth (DD/MM/YYYY)",
            type: "text",
            required: true,
          },
          {
            question: "Proof of Date of Birth.",
            type: "file",
            required: true,
          },
          {
            question: "Upload certificate of last 10K Ran.",
            type: "file",
            required: false,
          },
          {
            question: "Website link of last 10K result.",
            type: "text",
            required: false,
          },
          {
            question: "Upload certificate of last 5K Ran.",
            type: "file",
            required: false,
          },
          {
            question: "Website link of 5K Ran.",
            type: "text",
            required: false,
          },
          {
            question: "10K ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "5", "5+"],
            required: true,
          },
          {
            question: "5K ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "5", "5+"],
            required: true,
          },
          {
            question: "TShirt Size.",
            type: "radio",
            options: [
              "XS: 34",
              "S: 36",
              "M: 38",
              "L: 40",
              "XL: 42",
              "XXL: 44",
              "XXS: 32",
              "30",
              "28",
              "26",
              "24",
            ],
            required: true,
          },
          {
            question: "I have read and accept the liablity waiver.",
            type: "checkbox",
            options: ["Read and Accept"],
            required: true,
          },
          {
            question: "Country",
            type: "text",
            required: true,
          },
          {
            question: "Nationality",
            type: "text",
            required: true,
          },
          {
            question: "Group/Organisation Name.",
            type: "text",
            required: false,
          },
          {
            question: "Group ID/Ticket",
            type: "file",
            required: false,
          },
        ],
      },
      {
        name: "2K Run for Doon (Non Competitive)",
        description: "2k Run for Doon (Run + Walk)",
        price: 525,
        quantity: 50,
        formFields: [
          {
            question: "Full Name",
            type: "text",
            required: true,
          },
          {
            question: "Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Name",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Email",
            type: "email",
            required: true,
          },
          {
            question: "Blood Group",
            type: "radio",
            options: ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-", "A1B+"],
            required: true,
          },
          {
            question: "Gender",
            type: "radio",
            options: ["Male", "Female", "Others"],
            required: true,
          },
          {
            question: "City",
            type: "text",
            required: true,
          },
          {
            question: "Date of Birth (DD/MM/YYYY)",
            type: "text",
            required: true,
          },
          {
            question: "Proof of Date of Birth.",
            type: "file",
            required: true,
          },
          {
            question: "TShirt Size.",
            type: "radio",
            options: [
              "XS: 34",
              "S: 36",
              "M: 38",
              "L: 40",
              "XL: 42",
              "XXL: 44",
              "XXS: 32",
              "30",
              "28",
              "26",
              "24",
            ],
            required: true,
          },
          {
            question: "I have read and accept the liablity waiver.",
            type: "checkbox",
            options: ["Read and Accept"],
            required: true,
          },
          {
            question: "Country",
            type: "text",
            required: true,
          },
          {
            question: "Nationality",
            type: "text",
            required: true,
          },
          {
            question: "Group/Organisation Name.",
            type: "text",
            required: false,
          },
          {
            question: "Group ID/Ticket",
            type: "file",
            required: false,
          },
        ],
      },
      {
        name: "5K Run",
        description: "5K Run",
        price: 825,
        quantity: 50,
        formFields: [
          {
            question: "Full Name",
            type: "text",
            required: true,
          },
          {
            question: "Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Name",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Email",
            type: "email",
            required: true,
          },
          {
            question: "Blood Group",
            type: "radio",
            options: ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-", "A1B+"],
            required: true,
          },
          {
            question: "Gender",
            type: "radio",
            options: ["Male", "Female", "Others"],
            required: true,
          },
          {
            question: "City",
            type: "text",
            required: true,
          },
          {
            question: "Date of Birth (DD/MM/YYYY)",
            type: "text",
            required: true,
          },
          {
            question: "Proof of Date of Birth.",
            type: "file",
            required: true,
          },
          {
            question: "Upload certificate of last 5K Ran.",
            type: "file",
            required: false,
          },
          {
            question: "Website link of last 5K Ran result.",
            type: "text",
            required: false,
          },
          {
            question: "5K ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "5", "5+"],
            required: true,
          },
          {
            question: "TShirt Size.",
            type: "radio",
            options: [
              "XS: 34",
              "S: 36",
              "M: 38",
              "L: 40",
              "XL: 42",
              "XXL: 44",
              "XXS: 32",
              "30",
              "28",
              "26",
              "24",
            ],
            required: true,
          },
          {
            question: "I have read and accept the liablity waiver.",
            type: "checkbox",
            options: ["Read and Accept"],
            required: true,
          },
          {
            question: "Country",
            type: "text",
            required: true,
          },
          {
            question: "Nationality",
            type: "text",
            required: true,
          },
          {
            question: "Group/Organisation Name.",
            type: "text",
            required: false,
          },
          {
            question: "Group ID/Ticket",
            type: "file",
            required: false,
          },
        ],
      },
      {
        name: "5K Fun Run (Non Competitive)",
        description: "5K Fun Run",
        price: 750,
        quantity: 50,
        formFields: [
          {
            question: "Full Name",
            type: "text",
            required: true,
          },
          {
            question: "Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Name",
            type: "text",
            required: true,
          },
          {
            question: "Emergency Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Email",
            type: "email",
            required: true,
          },
          {
            question: "Blood Group",
            type: "radio",
            options: ["O+", "O-", "A+", "A-", "B+", "B-", "AB+", "AB-", "A1B+"],
            required: true,
          },
          {
            question: "Gender",
            type: "radio",
            options: ["Male", "Female", "Others"],
            required: true,
          },
          {
            question: "City",
            type: "text",
            required: true,
          },
          {
            question: "Date of Birth (DD/MM/YYYY)",
            type: "text",
            required: true,
          },
          {
            question: "Proof of Date of Birth.",
            type: "file",
            required: true,
          },
          {
            question: "5K ran in last 1 year.",
            type: "radio",
            options: ["0", "1", "2", "3", "4", "5", "5+"],
            required: true,
          },
          {
            question: "TShirt Size.",
            type: "radio",
            options: [
              "XS: 34",
              "S: 36",
              "M: 38",
              "L: 40",
              "XL: 42",
              "XXL: 44",
              "XXS: 32",
              "30",
              "28",
              "26",
              "24",
            ],
            required: true,
          },
          {
            question: "I have read and accept the liablity waiver.",
            type: "checkbox",
            options: ["Read and Accept"],
            required: true,
          },
          {
            question: "Country",
            type: "text",
            required: true,
          },
          {
            question: "Nationality",
            type: "text",
            required: true,
          },
          {
            question: "Group/Organisation Name.",
            type: "text",
            required: false,
          },
          {
            question: "Group ID/Ticket",
            type: "file",
            required: false,
          },
        ],
      },
      {
        name: "Virtual (TShirt + Medal)",
        description:
          "Fee Inclued: T-Shirt, Medal, e-certificate, Shipping Charges",
        price: 700,
        quantity: 50,
        formFields: [
          {
            question: "Full Name",
            type: "text",
            required: true,
          },
          {
            question: "Contact Number",
            type: "text",
            required: true,
          },
          {
            question: "Email",
            type: "email",
            required: true,
          },
          {
            question: "Gender",
            type: "radio",
            options: ["Male", "Female", "Others"],
            required: true,
          },
          {
            question: "TShirt Size.",
            type: "radio",
            options: [
              "XS: 34",
              "S: 36",
              "M: 38",
              "L: 40",
              "XL: 42",
              "XXL: 44",
              "XXS: 32",
              "30",
              "28",
              "26",
              "24",
            ],
            required: true,
          },
          {
            question: "Country",
            type: "text",
            required: true,
          },
          {
            question: "Nationality",
            type: "text",
            required: true,
          },
          {
            question: "Address",
            type: "text",
            required: true,
          },
          {
            question: "Pincode/Zipcode/Postcode",
            type: "text",
            required: true,
          },
        ],
      },
    ],
    faqs: "",
  };

  // ****** Uncomment if want to add event*********
  const handleAddEvent = () => {
    console.log("Adding Triggered");
    axios
      .post(`${process.env.REACT_APP_BACKEND_LINK}/addevent`, eventData)
      .then((res) => console.log(res))
      .catch((err) => console.log(err));
  };

  return (
    <div>
      <h1>Add Event</h1>
      <button onClick={handleAddEvent}>Add</button>
    </div>
  );
}
